/* ============================================
   CA Account Click Handler
   Handles account icon click behavior:
   - SwitchBot App: call app.jsAccountClick()
   - Browser logged-in: navigate to /account
   - Browser not logged-in: show login popup
   ============================================ */

function caAccountClick(el) {
  var isSwitchBotApp = window.navigator.userAgent.includes('SwitchBot');
  var isLoggedIn = el.getAttribute('data-logged-in') === 'true';

  if (isSwitchBotApp) {
    try {
      app.jsAccountClick();
    } catch (e) {
      console.log('caAccountClick: app.jsAccountClick() error', e);
    }
    return false;
  }

  if (isLoggedIn) {
    window.location.href = '/account';
    return false;
  }

  // Not logged in + not in app → show popup
  var popup = document.getElementById('ca-account-popup');
  if (popup) {
    popup.classList.add('active');
  }
  return false;
}
